export default __webpack_public_path__ + "static/media/complementary--trucks-go-right-ahead--g1.b575da79.png";